import React, { useEffect, useState } from "react";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import { fetchUserData, memberActionUpdateAPI } from "../../api/user";
import useSocket from "../../hooks/useSocket";
import { ActiveHeartIcon, NonActiveHeartIcon } from "../../icons";
import UserProfileDetails from "../user-profile/UserProfileDetails";
import UserAboutText from "../user-profile/UserAboutText";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, IconButton, Typography } from "@mui/material";
import UserPhotosLayout from "./bot-profile-chat/UserPhotosLayout";
import EditHeading from "./bot-profile-chat/EditHeading";
import NewLiveLocationDetails from "./bot-profile-chat/NewLiveLocationDetails";
import UserInfoSection from "./bot-profile-chat/UserInfoSection";
import EditAboutInfo from "./bot-profile-chat/EditAboutInfo";
import EditAboutLonging from "./bot-profile-chat/EditAboutLonging";
import EditLuxeInfo from "./bot-profile-chat/EditLuxeInfo";
import VerificationSection from "./bot-profile-chat/VerificationSection";

const aboutContent = [
  {
    title: "About Me",
    paragraphs: [
      `I want a submissive partner for me. Don't want to talk about myself much. I'm dominant by nature, but can switch too. I love to explore new experiences. I like open-minded and non-judgmental people. 🎈🌼`,
      `I have done B.Sc. with honours in microbiology. B.Des. in accessory design from NIFT. Pursuing M.Des. in Textile design. I'm a jewellery designer and a craft coordinator.`,
      `Apart from work and study, I love painting, inventing new cocktails, cooking, baking, cycling, hiking. I love doing yoga and meditation. I am a dog lover. I love collecting old coins. I am a foodie. Black and blue are my favourite colours.`,
    ],
  },
  {
    title: "What I am Seeking",
    paragraphs: [
      `I want you to open up like you never did before, be up for exploring whatever you want to try. It's very, very important to know about each other first. I want both of us to enjoy to its fullest.`,
      `You can never keep a connection forever. So be it today or tomorrow, we will be apart. I want to build up such a good bonding so that we both can cherish what we left behind and see each other in good books. The friendship should remain.`,
      `If you think you want to know more about me... then what are you waiting for? Swiping right won't help... come up with writing something really interesting.`,
    ],
  },
];

const ProfileCardRight = ({ closeProfileCard, userId, senderId }) => {
  const [userData, setUserData] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const { socket } = useSocket();

  const fetchData = async () => {
    try {
      await fetchUserData(userId, setUserData, false, senderId);
    } catch (error) {
      console.error("Error while loading real-time data", error);
    }
  };

  const emitProfileActivity = (action) => {
    if (socket && senderId && userId) {
      socket.emit("profileActivity", {
        userId: senderId,
        targetUserId: userId,
        action,
      });
    }
  };

  const toggleFavorite = async (e) => {
    e.stopPropagation();
    if (isLiked) return;
    try {
      await memberActionUpdateAPI({
        memberId: senderId,
        data: {
          action: "LIKE",
          targetUserId: userId,
        },
      });
      setIsLiked(true);
      setTimeout(() => {
        emitProfileActivity("like");
      }, 1000);
    } catch (error) {
      console.error("Error while liking profile", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [userId]);

  useEffect(() => {
    const liked =
      userData?.activityLogs?.some(
        (log) => log.action === "LIKE" && log.userId === senderId
      ) || userData?.isLiked;
    setIsLiked(Boolean(liked));
  }, [userData, senderId]);


  useEffect(() => {
    emitProfileActivity("view");
  }, [socket, senderId, userId]);

  return (
    <Box
      className="modal-dialog-scrollable border-start"
      sx={{
        minWidth: {
          xl: 280,
          lg: '260px',
          md: 280,
          sm: 280,
          xs: 280
        },
        maxWidth: 320,
        display: "flex",
        flexDirection: "column",
        height: "100vh", // full height for fixed header+footer
        position: "relative",
        // position: 'absolute',
        // right: '0'
      }}
    >
      <Box className="modal-content" sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>

        {/* FIXED HEADER */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            background: "#fff", fontWeight: 'bold', color: '#000',
            px: 1,
            py: 2.4,
            borderBottom: "1px solid #ddd",
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >  <Typography textAlign="center" fontWeight={600} sx={{ fontSize: '18px', fontWeight: '600' }}>
            Profile Details
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 1 }}>
            <IconButton
              onClick={toggleFavorite}
              sx={{
                width: '32px',
                height: '32px',
                border: '1px solid #ccc'
              }}
              size="small"
            >
              {isLiked ? (
                <ActiveHeartIcon style={{ width: 18, height: 18 }} />
              ) : (
                <NonActiveHeartIcon style={{ width: 18, height: 18 }} />
              )}
            </IconButton>
            <IconButton
              onClick={closeProfileCard}
              sx={{
                width: '32px',
                height: '32px',
                border: '1px solid #ccc'
              }}
              size="small"
            >
              <ArrowForwardIosIcon sx={{ fontSize: '18px' }} />
            </IconButton>
          </Box>
        </Box>

        {/* SCROLLABLE BODY */}
        <Box
          className="modal-body overflowauto"
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            p: 0,
            background: "#fff",
          }}
        >
          <Box className="profile-cardRight p-0">

            <Box
              sx={{
                flexGrow: 1,
                overflowY: "auto",
                p: 0,
                pb: 12, // space for footer
              }}
            >
              <UserPhotosLayout
                photos={userData?.publicPhotos || []}
                title="Public Photos"
                isEditable={false}
                showExtraCount={true}
                classCardMedia="Rtmedia"
                classTitlebg="Rttitlebg"
                classTitle="Rttitle"
                classTotalPhoto="Rttotalphoto"
                height70Img="height70Img"
              />

              <UserPhotosLayout
                photos={userData?.privatePhotos || []}
                title="Private Photos"
                isEditable={false}
                showExtraCount={true}
                classCardMedia="Rtmedia"
                classTitlebg="Rttitlebg"
                classTitle="Rttitle"
                classTotalPhoto="Rttotalphoto"
                height70Img="height70Img"
              />
              {userData?.myHeading &&
                <EditHeading
                  myHeading={userData?.myHeading}
                  isEditBtn={false}
                  className="pdx"
                  font16in14="fonmgset"
                />
              }
              <NewLiveLocationDetails userData={userData} />
              <UserInfoSection
                memberData={userData}
                isEditBtn={false}
                fieldsToShow={[
                  "Gender",
                  "Occupation",
                  "Height",
                  "Relationship",
                  "Intent",
                  "Who are you interested in",
                  "Location",
                ]}
                className="pdx"
                classflexinBlock="flexinBlock"
              />

              {userData?.aboutUsDescription && <EditAboutInfo memberData={userData} isEditBtn={false} className="pdx" font16in14="fonmgset" />}
              {/* {userData?.preferences?.aboutPartnerDescription && <EditAboutLonging memberData={userData} isEditBtn={false} className="pdx" font16in14="fonmgset" isRtsdbtnchat="px14font" />} */}
              {/* {userData?.preferences?.aboutPartnerDescription && <EditAboutLonging isEditBtn={false} className="pdx" font16in14="fonmgset" isRtsdbtnchat="px14font" />} */}
              {/* {userData?.luxuryInterests && <EditLuxeInfo memberData={userData} isEditBtn={false} className="pdx" isRtsdbtnchat="px14font" />} */}
              {
                (
                  userData?.isInstagramVerified ||
                  userData?.isLinkedinVerified ||
                  userData?.isFacebookVerified ||
                  userData?.isTwitterVerified ||
                  userData?.isProfileVerified ||
                  userData?.isIdVerified
                ) &&
                <VerificationSection memberData={userData} showOnlyVerified className="pdx" font16in14="fonmgset" />
              }
            </Box>
          </Box>
        </Box>



      </Box>
    </Box>
  );
};

export default ProfileCardRight;
